import React from "react";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import clsx from "clsx";

import WebRoutes from "../../../routes.js";
import Image from "../../../../base/components/image.js";
import ButtonLink from "../../../../base/links/button_link.js.jsx";

const styles = theme => ({
  root: {
    // height: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  content: {
    margin: "0px auto",
    maxWidth: "439px",
    padding: "20px 0px 20px",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    ['@media (max-width: 768px)']: {
      padding: "68px 24px 0"
    }
  },
  backContainer: {
    display: "flex",
    // marginTop: "8px",
    marginBottom: "60px",
    width: "70%",
    backgroundColor: "white",
    color: theme.palette.blueMain,
    borderColor: theme.palette.blueMain,
    borderStyle: "solid",
    borderWidth: "medium",
    '&:hover': {
      backgroundColor: theme.palette.white
    }
  },
  desktop: {
    display: "flex",
    ['@media (max-width: 992px)']: {
      display: "none",
    },
  },
  mobile: {
    display: "none",
    ['@media (max-width: 992px)']: {
      display: "flex",
      alignItems: "center",
      position: "relative",
    },
  },
  image: {
    width: "730px",
    height: "71px",
    marginLeft: "100px",
    marginBottom: "40px",
  },
  mobileImage: {
    width: "244px",
    height: "134px",
  },
});

class BaseSessionPage extends React.Component {

  render() {
    const { classes, children } = this.props;
    return <div className = { classes.root } >
      <div className = { classes.content } >
        <Image className = { clsx(classes.desktop, classes.image) }
                scaleMode = "contain"
                alt = { I18n.t("shared.schon_dass_sie_da_sind") }
                src = "/icons/schoen/hl-schoen.png" />
        <Image className = { clsx(classes.mobile, classes.mobileImage) }
                scaleMode = "contain"
                alt = { I18n.t("shared.schon_dass_sie_da_sind") }
                src = "/icons/schoen/hl-schoen-mobile.png?13" />
        { children }
        <ButtonLink className = { clsx(classes.desktop, classes.backContainer) } to = { WebRoutes.xavin() }>
          { I18n.t("shared.back") }
        </ButtonLink>
        <ButtonLink className = { clsx(classes.mobile, classes.backContainer) } to = { WebRoutes.xavin() }>
          { I18n.t("shared.just_back") }
        </ButtonLink>
      </div>
    </div>
  }
}

BaseSessionPage.propTypes = {
  children: PropTypes.node
};

export default withStyles(
  (theme) => ({
    ...styles(theme),
  }),
  { withTheme: true },
)(BaseSessionPage);